module.exports = __webpack_public_path__ + "img/undraw_pending_approval_xuu9.1aa1bd3f.svg";